import { render, staticRenderFns } from "./NotExpectModal.vue?vue&type=template&id=620cc49d&scoped=true"
import script from "./NotExpectModal.vue?vue&type=script&lang=js"
export * from "./NotExpectModal.vue?vue&type=script&lang=js"
import style0 from "./NotExpectModal.vue?vue&type=style&index=0&id=620cc49d&prod&lang=css"
import style1 from "./NotExpectModal.vue?vue&type=style&index=1&id=620cc49d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_ckru7f3yypsoan6edyu23zfbiq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620cc49d",
  null
  
)

export default component.exports